/************
 Swipers
 ************/

// thumbnails mobile
let productV10ThumbnailImages = new Swiper("#productV10ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV10ThumbnailsNext',
        prevEl: '#productV10ThumbnailsPrev',
    },
});

// main swiper
let productV10Images = new Swiper("#productV10Swiper", {
    navigation: {
        nextEl: '#productV10Swiper .swiper-button-next',
        prevEl: '#productV10Swiper .swiper-button-prev',
    },
    loop: true,
    thumbs: {
        swiper: productV10ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV10GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV10Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV10Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();
        popup.querySelector("video").play();
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV10Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV6() {
    // There are 3 senarios to determine the active variant
    // 1. Has only a default variant
    // 2. the color/background swatch
    // 3. the basic dropdown

    // check for an active color swatch
    if (product.variants.length === 1) {
        activeVariant = product.variants[0];
    } else if (document.querySelector(".productV10FormGroup.active")) {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector(".productV10FormGroupFlexColor:checked").value)
        })[0];
    } else {
        activeVariant = product.variants.filter((variant) => {
            return variant.id === parseInt(document.querySelector("#productV10FormVariants").value)
        })[0];
    }

    // find variant image
    if (activeVariant.featured_image) {
        const variantImage = document.querySelector(`.productV10SwiperSlide[id="${activeVariant.featured_image.id}"]`);
        if (variantImage) {
            productV10Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // check product.handle
    if (product.handle == "portable-vibrating-massage-roller-vibit-roll-2") {
      activeVariant.price = 9900;
      activeVariant.compare_at_price = 16500;
    }

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for addon
    const hasAddon = document.querySelector("#productV10AddonCheckboxInput:checked")
    if (hasAddon) {
        total += parseInt(document.querySelector(".productV10AddonFormVariantsItem:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV10AddonFormVariantsItem:checked").dataset.compare);
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        const prefix = hasAddon ? "BUNDLE" : "";
        document.querySelector("#productV10PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV10PriceActual").textContent = `${prefix} ${price(total, true)}`;
        document.querySelector("#productV10PriceSavings").textContent = `SAVE ${savingsPercent}%`;
        document.querySelector("#productV10PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV10PriceCompare").textContent = "";
        document.querySelector("#productV10PriceActual").textContent = price(total, true);
        document.querySelector("#productV10PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV10ATC").classList.remove("oos");
        document.querySelector("#productV10ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV10ATC").classList.add("oos");
        document.querySelector("#productV10ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // update BOGO box prices
    let BOGOExists = document.querySelector('.productV10BOGO') || false;
    if (BOGOExists) {
        document.querySelector('.productV10BOGOPriceReal').textContent = price(activeVariant.price, true);
        document.querySelector('.productV10BOGOPriceCompare').textContent = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            document.querySelector('.productV10BOGOPriceCompare').textContent = price(activeVariant.compare_at_price, true);
        }
    }
}

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV10FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV10FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV6();
    });
});

// variant dropdown support on change
document.querySelector("#productV10FormVariants")?.addEventListener("change", updateProductV6);


// if url has bundle, preselect it
if (urlParams.has("bundle")) {
    document.querySelector(`.productV10BundleOptionsItemInput[value="${urlParams.get("bundle")}"]`)?.parentElement.click();
}

/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV10QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV10QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV10QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV10QuantityValue").textContent = quantity;
});


/***************
 Product Addon
 ****************/

// select addon
if (document.querySelector("#productV10Addon")) {
    // input change
    document.querySelector("#productV10AddonCheckboxInput").addEventListener("change", function () {
        // update product form
        updateProductV6();

        // on check
        if (this.checked) {
            // update active class on parent
            document.querySelector("#productV10Addon").classList.add("active");

            // uncheck bogo button
            document.querySelector('.productV10BOGO')?.classList.remove('active');

            quantity = 1;

            // hide note
            document.querySelector('#productV10Note')?.classList.remove('active');

            // switch slides
            productV10Images.slideTo(productV10Images.slides.length - 1);
        } else {
            // remove active class on parent
            document.querySelector("#productV10Addon").classList.remove("active");

            // check bogo button
            document.querySelector('.productV10BOGO')?.classList.add('active');
            productV10Images.slideTo(0);

            quantity = 2;

            // show note
            document.querySelector('#productV10Note')?.classList.add('active');

        }
    });

    // variant selection change
    document.querySelectorAll(".productV10AddonFormVariantsItem").forEach(function (element) {
        element.addEventListener("change", updateProductV6);
    });

    // if url has addon, preselect it
    if (urlParams.has("addon")) {
        document.querySelector("#productV10AddonCheckbox").click();
    }

    /***************
     BOGO Button
     ****************/
    // toggle between bogo and addon
    document.querySelector('.productV10BOGO')?.addEventListener('click', function () {
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            document.querySelector("#productV10AddonCheckbox").click();

            quantity = 1;

            // hide note
            document.querySelector('#productV10Note').classList.remove('active');
        } else {
            this.classList.add('active');
            document.querySelector("#productV10AddonCheckbox").click();
            productV10Images.slideTo(0)

            quantity = 2;
            // show note
            document.querySelector('#productV10Note').classList.add('active');
        }

    });
}

/**************
 ORDERS REMAINING
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV10ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // determine which time of productV10 we're adding to cart
    // 1. Bundle
    // 2. Single Product

    // create form data
    let formData = {
        items: []
    };

    // check for BOGO (default to 2 quantity)
    if (document.querySelector('.productV10BOGO')?.classList.contains('active')) {
        quantity = 2;
    }


    // normal product

    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });


    // check if addon
    const hasAddon = !!document.querySelector("#productV10AddonCheckboxInput:checked");
    if (hasAddon) {
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV10AddonFormVariantsItem:checked").value),
        });
    }

    // check if vibit roll, add tutorial video
    // if (product.handle === "the-vibit" || hasAddon) {
    //     formData.items.push({
    //         quantity: 1,
    //         id: tutorial.variants[0].id,
    //     });
    // }

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        // add gift free gift
        formData.items.push(
            {
                quantity: 1,
                id: 49838321369368
            }
        )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV10
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV10ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV10AddonCheckboxInput").checked) {
            document.querySelector("#productV10AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV10ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV10ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV10ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV10Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV10DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

